"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceError = /** @class */ (function () {
    function ServiceError(data) {
        this.code = data.code;
        this.message = data.message;
        this.target = data.target;
        this.details = data.details;
    }
    ServiceError.prototype.getFieldError = function (name) {
        if (this.target === name) {
            return this.message;
        }
        if (this.details) {
            var error = this.details.filter(function (d) { return d.target === name; });
            if (error) {
                return error.map(function (er) { return er.message; }).join('\n');
            }
        }
        return undefined;
    };
    ServiceError.prototype.toString = function () {
        var errorMessage = this.message;
        errorMessage += '\n';
        if (this.details) {
            errorMessage = '';
            errorMessage += this.details.map(function (er) { return "-" + er.message; }).join('\n');
        }
        return errorMessage;
    };
    return ServiceError;
}());
exports.ServiceError = ServiceError;
//# sourceMappingURL=ServiceError.js.map